import { comparisonData, trustItems } from '@/mocks/siteContent';
import { Link } from 'react-router-dom';

export default function ContentSection() {
  return (
    <>
      <section className="py-14 md:py-20 bg-background-50">
        <div className="max-w-5xl mx-auto px-4 md:px-6">
          <div className="text-center mb-12">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
              Sugargoo Spreadsheet vs Traditional Searching
            </h2>
            <p className="mt-3 text-foreground-500 max-w-xl mx-auto text-sm md:text-base">
              See how our organized approach compares to the old way of hunting for products.
            </p>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full border-collapse">
              <thead>
                <tr className="border-b border-background-200">
                  <th className="text-left py-4 px-4 text-sm font-semibold text-foreground-700">Feature</th>
                  <th className="text-left py-4 px-4 text-sm font-semibold text-foreground-400">Traditional Search</th>
                  <th className="text-left py-4 px-4 text-sm font-semibold text-primary-600">Sugargoo Spreadsheet</th>
                </tr>
              </thead>
              <tbody>
                {comparisonData.map((row) => (
                  <tr key={row.feature} className="border-b border-background-200/60">
                    <td className="py-3 px-4 text-sm font-medium text-foreground-800">{row.feature}</td>
                    <td className="py-3 px-4 text-sm text-foreground-400">{row.traditional}</td>
                    <td className="py-3 px-4 text-sm text-primary-600 font-medium">{row.spreadsheet}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section className="py-14 md:py-20 bg-background-100">
        <div className="max-w-5xl mx-auto px-4 md:px-6">
          <div className="text-center mb-12">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
              What Makes Sugargoo Spreadsheet Special?
            </h2>
            <p className="mt-3 text-foreground-500 max-w-2xl mx-auto text-sm md:text-base">
              Sugargoo has become one of the most popular shopping agents for international buyers, and having an organized spreadsheet of finds makes the experience even better. Here&apos;s what sets our resource apart.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-3xl mx-auto">
            {trustItems.map((item) => (
              <div key={item.text} className="flex items-start gap-3 bg-background-50 border border-background-200/70 rounded-lg p-4">
                <span className="w-6 h-6 flex items-center justify-center rounded-full bg-primary-100 flex-shrink-0 mt-0.5">
                  <i className={`${item.icon} text-primary-600 text-xs`}></i>
                </span>
                <span className="text-sm text-foreground-700 leading-relaxed">{item.text}</span>
              </div>
            ))}
          </div>

          <div className="mt-12 bg-background-50 border border-background-200/70 rounded-lg p-6 md:p-8 max-w-3xl mx-auto">
            <h3 className="font-heading text-xl font-bold text-foreground-900 mb-4">
              Getting Started with Sugargoo Spreadsheet
            </h3>
            <div className="prose prose-sm max-w-none text-foreground-600 space-y-3 leading-relaxed">
              <p>
                If you&apos;re new to the world of Sugargoo and international shopping agents, you might feel overwhelmed by the sheer volume of products available. That&apos;s exactly why the <strong className="text-foreground-900">Sugargoo Spreadsheet</strong> was created — to help shoppers like you find, compare, and discover the best products without spending hours scrolling through endless listings.
              </p>
              <p>
                Our spreadsheet categories cover everything from trendy sneakers and cozy hoodies to stylish bags and must-have accessories. Each category is carefully organized and linked directly to the main Sugargoo Spreadsheet website at <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-primary-600 hover:text-primary-700 underline">kaspreadsheet.com</a>, where you can browse complete product lists and make your purchases.
              </p>
              <p>
                Whether you&apos;re looking for the latest streetwear drops, affordable everyday basics, or unique finds you won&apos;t see anywhere else, the Sugargoo Spreadsheet has something for everyone. And with our detailed shopping guides and shipping information, you&apos;ll know exactly what to expect — from pricing to delivery times.
              </p>
              <p>
                Ready to dive deeper? Check out our <Link to="/sugargoo-spreadsheet-guide" className="text-primary-600 hover:text-primary-700 underline font-medium">complete Sugargoo Spreadsheet guide</Link> for a comprehensive walkthrough of everything you need to know about shopping with Sugargoo in 2026.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}